import React from 'react';
import { useWebSocket } from '../contexts/WebSocketContext';
import type { ConnectionStatus } from '../types/websocket';

const STATUS_CONFIG: Record<
  ConnectionStatus,
  {
    color: string;
    bgColor: string;
    glowColor: string;
    label: string;
    pulse: boolean;
  }
> = {
  connected: {
    color: '#1C76A2', // bull-blue
    bgColor: 'bg-bull-blue',
    glowColor: 'rgba(28, 118, 162, 0.4)',
    label: 'Connected',
    pulse: true,
  },
  connecting: {
    color: '#C2A14E', // accent-yellow
    bgColor: 'bg-accent-yellow',
    glowColor: 'rgba(194, 161, 78, 0.4)',
    label: 'Connecting...',
    pulse: false,
  },
  disconnected: {
    color: '#D8483B', // bear-red
    bgColor: 'bg-bear-red',
    glowColor: 'rgba(216, 72, 59, 0.4)',
    label: 'Disconnected',
    pulse: false,
  },
};

export const ConnectionStatusIndicator: React.FC = () => {
  const { connectionStatus } = useWebSocket();
  const config = STATUS_CONFIG[connectionStatus];

  return (
    <div className="flex items-center gap-2">
      <div className="relative flex items-center justify-center w-4 h-4">
        {/* LED indicator */}
        <div
          className={`w-2 h-2 rounded-full ${config.bgColor} ${
            config.pulse ? 'animate-pulse' : ''
          }`}
          style={{
            boxShadow: `0 0 8px ${config.glowColor}, 0 0 12px ${config.glowColor}`,
          }}
        />
      </div>
      <span className="text-xs text-gray-400">{config.label}</span>
    </div>
  );
};
